import { useQuery } from '@tanstack/react-query';
import { Note } from '../../../types/Note';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchNote = async (uuid: string) => {
  const response = await CustomAxios.get<Note>(`notes/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetNoteByIdProps {
  uuid: string;
}
export function useGetNoteById({ uuid }: UseGetNoteByIdProps) {
  const query = useQuery({
    queryKey: [queryKeys.allNotes, uuid],
    queryFn: () => fetchNote(uuid),
  });

  return query;
}
